import {createBrowserHistory} from "history";

export const SkApplyHistory = createBrowserHistory();
